import React from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { useMemberAuth } from '../contexts/MemberAuthContext';

function MemberProtectedRoute() {
  const { currentMember, loading } = useMemberAuth();
  const { orgId } = useParams();

  if (loading) {
    return (
      <div className="bb-loading-screen">
        <div className="bb-loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!currentMember) {
    return <Navigate to={`/BespokeBridge/${orgId}/member/login`} replace />;
  }

  if (orgId && currentMember.orgId !== orgId) {
    return <Navigate to={`/BespokeBridge/${orgId}/member/login`} replace />;
  }

  return <Outlet />;
}

export default MemberProtectedRoute;
